<template>
    <div class="mt-4">
        <!--INFORMACION DE LA TAREA-->
        <div>
            <div>
                <h4 class="title-informacion">Información de la Evaluación</h4>
            </div>
            <div class="vx-row">
                <!--COLUMNA IZQUIERDA-->
                <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 ">
                    <div class="container-informacion">
                        <p class="font-bold">Materia:</p>
                        <span>{{ ObjectSelected.libro.nombrelibro }}</span>
                        <br> <br>
                        <p class="font-bold">Fecha de envio:</p>
                        <span>{{ ObjectSelected.fecha_inicio }}</span>
                        <br> <br>
                        <p class="font-bold">Fecha de entrega:</p>
                        <span>{{ ObjectSelected.fecha_fin }}</span>
                        <br> <br>
                        <p class="font-bold">Codigo curso:</p>
                        <span>{{ ObjectSelected.codigo_curso }}</span>
                        <br> <br>
                        <p class="font-bold">Intentos:</p>
                        <span>{{ ObjectSelected.intentos }}</span>
                        <br> <br>
                        <div v-if="ObjectSelected.intentos > 1">
                            <p class="font-bold">Tipo calificación:</p>
                            <span v-if="ObjectSelected.tipo_calificacion == 0">Promediar intentos</span>
                            <span v-else>Tomar la calificación más alta</span>
                        </div>
                    </div>
                </div>
                <!--COLUMNA DERECHA-->
                <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 ">
                    <div v-if="ready">
                        <EvaluacionReporteGeneralVue :arregloReporte="arregloReporte"/>
                    </div>
                    <div v-else>
                        <span>No hay calificaciones aún</span>
                    </div>
                </div>
            </div>
        </div>
        <!--REVISAR TAREAS-->
        <div class="mt-5">
            <div>
                <h4 class="title-informacion">Calificaciones
                </h4>
            </div>
            <div class="container-informacion">
                <div v-if="arregloEstudiantes.length > 0">
                    <EvaluacionCalificacionesVue @changeHandle="changeHandle"  :ObjectSelected="ObjectSelected" :arregloEstudiantes="arregloEstudiantes" :userDocente="userDocente"/>
                </div>
                <div v-else>
                    <span>No hay estudiantes</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
 const EvaluacionCalificacionesVue = () => import('./EvaluacionCalificaciones.vue');
 const EvaluacionReporteGeneralVue = () => import('./EvaluacionReporteGeneral.vue');
export default{
    components:{
        EvaluacionCalificacionesVue,
        EvaluacionReporteGeneralVue
    },
    data(){
        return{
            usuario:[],
            arregloRespuestas:[],
            arregloEstudiantes:[],  
            arregloReporte:[],
            userEstudiante:false,
            userDocente:false,
            ready:false,
        }
    },
    created(){
      let me = this
      me.usuario = JSON.parse(localStorage.getItem("usuario"))[0]
    },
    mounted() {
        let me = this;
        if(me.usuario.id_group == 4) me.userEstudiante = true
        if(me.usuario.id_group == 6) me.userDocente = true
        me.getEstudiantes()
    },
    props:{
        ObjectSelected:{
            type:Object,
            default:function(){
                return {}
            }
        }
    },
    methods: {
        changeHandle(){
            let me = this;
            me.getEstudiantes()
        },
        removeItemFromArr(arr, item) {
            let me = this;
            const i = arr.indexOf(item)
            arr.splice(i, 1)
            if (item.local == 1) {
                me.deleteOnlyFile(item.id)
            }
        },
        getEstudiantes(){
           let me = this;
           me.ready = false
           me.arregloReporte = []
           this.$http.get(this.$server_url+`evaluacion?getCalificacionesEvaluacion=1&idEvaluacion=${me.ObjectSelected.id}`)
                .then(function (res) {
                    me.arregloEstudiantes = res.data
                    //si hay estudiantes con evaluaciones
                    if(me.arregloEstudiantes.length > 0){
                        me.arregloReporte = me.arregloEstudiantes.filter(item => item.evaluacion.length > 0)
                        if(me.arregloReporte.length > 0){
                            me.ready = true
                        }
                    }
                })
                .catch(function (error) {
                    console.log(error + ' error');
                    me.$vs.loading.close()
                })
        },
    },
}
</script>
<style lang="scss">
@import '@/assets/scss/general/general.scss';
.title-informacion{
    background-color: var(--fondo);
    padding: 10px;
    color:var(--titulo)
}
.container-informacion{
    border: 1px solid var(--border);
    padding: 20px;
}
.link{
    font-weight: 400;
    text-decoration: underline;
    cursor: pointer;
    transition: 1s ease;
}
.link:hover{
    color: cornflowerblue;
}
.letra2 {
    font-size: 11px;
}
.letra4{
    font-size: 12px;
    color: #3EA0EA;
    text-align: center;
}
.download {
    cursor: pointer;
}
.download:hover {
    text-decoration: underline;
    opacity: 1;
}
.alto {
    height: 150px;
    display: inline-block;
}
.boton{
    background-color: #1c84c6;
    color: white;
    padding: 10px;
    border-color: #fff!important;
    width: 200px;
    cursor: pointer;
    transition: 0.5s ease-in;
    border: none;
    border-radius: 5px;
}
.boton:hover{
    background-color: #095280;
}
.farchivo {
    margin-bottom: -10px;
    cursor: pointer;
    color: gray;
    width: 100%;
    font-size: 11px;
    line-height: 80%;
    transition: 1s ease all;
    padding: 10px 10px;
}

.farchivo:hover {
    background-color: #7C7B89;
    color: white;
    border-radius: 5px;
    transform: scaleY(2px);
}

</style>